<template>
  <v-dialog
    :retain-focus="false"
    v-model="deleteDialog"
    width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-icon  
        small 
        v-bind="attrs"
        v-on="on">
        mdi-delete
      </v-icon>
    </template>
    <v-card>
      <v-card-text v-if="!useOverwrite" class="delete-text" >
        {{ deleteText }}
      </v-card-text>
      <v-card-text v-else class="delete-text" >
        {{ overwriteText }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          text
          @click="toggleDeleteDialog()">
          Cancel
        </v-btn>
        <v-btn
          color="green"
          text
          @click="emitItemForDeletion(item)">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialogBox',
  props: {
    item: {
      type: Object,
      required: true
    },
    overwriteText: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {
      deleteDialog: false
    }
  },
  computed: {
    deleteText() {
      if (this.item.devices && this.item.devices.length > 0) {
        // return `This vehicle has an existing device assigned. If you proceed then the existing device will be unassigned and replaced with the selected device.`
        return 'This vehicle has an existing device assigned. If you proceed then this device will be unassigned.'
      }
      else {
        return `Are you sure you wish to delete vehicle : ${this.item.vehicle_name}?`
      }
    },
    useOverwrite() {
      return this.overwriteText.length > 0 ? true : false;
    }
  },
  methods: {
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    emitItemForDeletion(item) {
      this.$emit('deletionConfirmed', item);
      this.toggleDeleteDialog();
    }
  }
}
</script>

<style lang="scss" scoped>
  .delete-text {
    text-align: center;
    padding-top: 2em !important;
    font-size: 20px;
  }
</style>